export const pharmacologicalCards = [
  {
    type: "firstLineOralAntihistamines",
    header: "First Line Therapy",
    subheader: "Oral Antihistamines",
    smallHeader: "Treat itchy nose, sneezing and rhinorrhea. ",
    clinicalPoints: () => {
      return (
        <div>
          <p className="text-[14px] text-gray-700 font-bold">
            Second Generation Oral Antihistamines
          </p>
          <ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
            <li className="">
              Intranasal corticosteroids are often combined with oral antihistamines
              to treat severe or resistant cases of allergic rhinitis
            </li>
            <li className="">
              Longer lasting; have less sedation; Cetirizine is most sedating
            </li>
            <li className="">
              If one antihistamine is not working, can switch to a different one
            </li>
            <li className="">
              Fexofenadine, cetirizine and desloratadine have some decongestant
              activity, although only <b>desloratadine</b> has an actual indication
            </li>
            <li className="">
              May reduce symptoms of allergic conjunctivitis -itching and tearing-
            </li>
            <li className="">
              Most effective when taken prophylactically, & taken regularly for duration of allergen contact (allergy season)
            </li>
            <li className="">
              <b>
                RUPALL NOTE : Use in patients with renal or hepatic impairment is not
                recommended due to no clinical experience.
              </b>
            </li>
          </ul>
        </div>
      );
    },
    populationLabel: "Second Generation Oral Antihistamines",
    pregnancy: () => {
      return (<ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
        <li className="">
          Refer pregnant patients to their primary care provider.
        </li>
        <li className="">
          Differential diagnosis for pregnancy rhinitis and allergic rhinitis
          cannot be distinguished.
        </li>
      </ul>);
    },
    breastfeeding: () => {
      return (<ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
        <li className="">
          Second-generation antihistamines are considered compatible while
          breastfeeding
        </li>
        <li className="">Monitor infant for sedation with cetirizine</li>
        <li className="">
          Avoid bilastine and rupatadine due to lack of safety data.
        </li>
      </ul>);
    }
  },
  {
    type: "firstLineIntranasalCorticosteroids",
    header: "First Line Therapy",
    subheader: "Intranasal Corticosteroids",
    smallHeader: "Controls sneezing, nasal congestion, and rhinorrhea. ",
    clinicalPoints: () => {
      return (
        <div className="flex flex-col gap-2">
          <p className="text-[14px] text-gray-700 font-bold">
            Intranasal Cortiosteroids
          </p>
          <ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
            <li className="">
              Intranasal corticosteroids are often combined with oral antihistamines
              to treat severe or resistant cases of allergic rhinitis
            </li>
          </ul>
          <p className="text-[14px] text-gray-700">Prescribing:</p>
          <ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
            <li className="">Prescribe maximum dose to start.</li>
            <li className="">
              Once symptoms are well controlled, taper dose at intervals of one week
              to the lowest effective dose as a maintenance dose.
            </li>
            <li className="">Continuous use more effective than as needed.</li>
            <li className="">2 to 4 weeks may be needed for maximal effects</li>
            <li className="">
              No evidence that any one agent is more effective than the other.
            </li>
            <li className="">
              Superior to oral and intranasal antihistamines, all INCS can cause
              nasal irritation and stinging.
            </li>
            <li className="">
              An unobstructed airway is necessary for optimal effect.
            </li>
            <li className="">
              A combination of oral antihistamine and INCS for severe or resistant
              cases.
            </li>
            <li className="">
              There is insufficient evidence to support this combination, however,
              some patients may wish to try it.
            </li>
            <li className="">
              If no effect is seen after a 2 to 4 week trial, it should be
              discontinued.
            </li>
          </ul>
          <p className="text-[14px] text-gray-700">
            How to Select One Over the Other:
          </p>
          <ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
            <li className="">
              Aqueous solution provides better intranasal deposition than dry powder.
            </li>
            <li className="">
              Patient preference for scented (formulations containing phenylethyl
              alcohol) versus non-scented products.
            </li>
            <li className="">
              Newer products (ciclesonide, mometasone and fluticasone furoate) have a
              smaller spray volume.
            </li>
            <li className="">
              Convenience of once daily dosing versus multiple daily doses cost
            </li>
          </ul>
        </div>
      );
    },
    populationLabel: "Intranasal Cortiosteroids",
    pregnancy: () => {
      return (
        <ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
          <li className="">
            Refer pregnant patients to their primary care provider.
          </li>
          <li className="">
            Differential diagnosis for pregnancy rhinitis and allergic rhinitis
            cannot be distinguished.
          </li>
          <li className="">
            A previous diagnosis of allergic rhinitis still requires referral
            during any trimester of pregnancy.
          </li>
          <li className="">
            Pregnancy can have differing effects on previously diagnosed Allergic
            rhinitis – exacerbate, improve, or remain unchanged.
          </li>
        </ul>
      );
    },
    breastfeeding: () => {
      return (
        <ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
          <li className="">
            Intranasal corticosteroids are considered compatible while
            breastfeeding/chestfeeding.
          </li>
          <li className="">
            Always review risk versus benefit assessment when prescribing when
            nursing
          </li>
        </ul>

      );
    },
    pediatrics: () => {
      return (
        <ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
          <li className="">
            Pharmacotherapy recommendations are comparable in adults and
            children.Each product has different dosing based on age and/or weight
          </li>
          <li className="">
            Intranasal Corticosteroids preferred agents: budesonide, fluticasone
            propionate, mometasone
          </li>
          <li className="">
            There are some concerns regarding growth suppression in children with
            prolonged use at recommended doses.
          </li>
          <li className="">
            To reduce potential systemic effects of INCSs: Continue to use other
            therapies (non-pharmacologic) to reduce the dose of INCS needed to
            control symptoms.
          </li>
        </ul>
      );
    }
  },
  {
    type: "stepUpIntranasalCorticosteroids",
    header: "Step Up Therapy",
    subheader: "Intranasal Corticosteroids",
    smallHeader: "Controls sneezing, nasal congestion, and rhinorrhea. ",
    clinicalPoints: () => {
      return (
        <div className="flex flex-col gap-2">
          <p className="text-[14px] text-gray-700 font-bold">
            Intranasal Cortiosteroids
          </p>
          <ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
            <li className="">
              Intranasal corticosteroids are often combined with oral antihistamines
              to treat severe or resistant cases of allergic rhinitis
            </li>
          </ul>
          <p className="text-[14px] text-gray-700">Prescribing:</p>
          <ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
            <li className="">Prescribe maximum dose to start.</li>
            <li className="">
              Once symptoms are well controlled, taper dose at intervals of one week
              to the lowest effective dose as a maintenance dose.
            </li>
            <li className="">Continuous use more effective than as needed.</li>
            <li className="">2 to 4 weeks may be needed for maximal effects.</li>
            <li className="">
              Use of an intranasal decongestant spray prior to the intranasal
              corticosteroid for first 2 to 3 days of therapy may be recommended to
              improve deposition of the corticosteroid.
            </li>
          </ul>
        </div>
      );
    },
    populationLabel: "Intranasal Cortiosteroids",
    pregnancy: () => {
      return (<ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
        <li className="">
          Refer pregnant patients to their primary care provider.
        </li>
        <li className="">
          Differential diagnosis for pregnancy rhinitis and allergic rhinitis
          cannot be distinguished.
        </li>
        <li className="">
          Pharmacists are required to prescribe within the Health Canada approved
          indication - allergic rhinitis.
        </li>
      </ul>);
    },
    breastfeeding: () => {
      return (
        <ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
          <li className="">
            Intranasal corticosteroids are considered compatible while
            breastfeeding.
          </li>
          <li className="">
            Always review risk versus benefit assessment when prescribing when
            nursing
          </li>
        </ul>
      );
    },
    pediatrics: () => {
      return (
        <ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
          <li className="">
            Intranasal Corticosteroids preferred agents: budesonide, fluticasone
            propionate, mometasone.
          </li>
          <li className="">
            There are some concerns regarding growth suppression in children with
            prolonged use.
          </li>
        </ul>
      );
    }
  },
  {
    type: "stepUpCombination",
    header: "Step Up Therapy",
    subheader: "Intranasal Corticosteroids/ Antihistamines",
    smallHeader: "Treats nasal congestion, runny nose and sneezing.",
    clinicalPoints: () => {
      return (
        <div className="flex flex-col gap-2">
          <p className="text-[14px] text-gray-700 font-bold">
            Intranasal Corticosteroids/ Antihistamines
          </p>
          <ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
            <li className="">
              Combination Options:
              <b>Intranasal antihistamine plus intranasal corticosteroid</b>: more
              effective for nasal congestion than either medication alone based on
              mostly short-term (14-day) data.
            </li>
            <li className="">
              Available Prescription Products:
              <b>azelastine/fluticasone propionate and olopatadine/mometasone</b>
            </li>
            <li className="">Take regularly to achieve the full effect</li>
            <li className="">Continuous use more effective than as needed</li>
          </ul>
        </div>
      );
    },
    populationLabel: "Intranasal Corticosteroids/ Antihistamines",
    pregnancy: () => {
      return (
        <ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
          <li className="">
            Refer pregnant patients to their primary care provider.
          </li>
          <li className="">
            Differential diagnosis for pregnancy rhinitis and allergic rhinitis
            cannot be distinguished.
          </li>
          <li className="">
            A previous diagnosis of allergic rhinitis still requires referral
            during any trimester of pregnancy.
          </li>
          <li className="">
            Pregnancy can have differing effects on previously diagnosed Allergic
            rhinitis - exacerbate, improve, or remain unchanged.
          </li>
        </ul>
      );
    },
    breastfeeding: () => {
      return (<ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
        <li className="">
          Intranasal corticosteroids are considered compatible while
          breastfeeding/chestfeeding.
        </li>
        <li className="">
          Always review risk versus benefit assessment when prescribing when
          nursing
        </li>
      </ul>);
    },
    pediatrics: () => {
      return (<ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
        <li className="">
          Pharmacotherapy recommendations are comparable in adults and
          children.Each product has different dosing based on age and/or weight
        </li>
        <li className="">
          Intranasal Corticosteroids preferred agents: budesonide, fluticasone
          propionate, mometasone
        </li>
        <li className="">
          There are some concerns regarding growth suppression in children with
          prolonged use at recommended doses.
        </li>
        <li className="">
          To reduce potential systemic effects of INCSs: Continue to use other
          therapies (non-pharmacologic) to reduce the dose of INCS needed to
          control symptoms.
        </li>
      </ul>);
    }
  },
  {
    type: "alternativeFirstLineCombination",
    header: "Alternative First Line Therapy",
    subheader: "Intranasal Corticosteroids/ Antihistamines",
    smallHeader: "Treats nasal congestion, runny nose and sneezing.",
    clinicalPoints: () => {
      return (
        <div className="flex flex-col gap-2">
          <p className="text-[14px] text-gray-700 font-bold">
            Intranasal Corticosteroids/ Antihistamines
          </p>
          <ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
            <li className="">
              Combination Options: more effective for nasal congestion than either
              medication alone based on mostly short-term (14-day) data.
            </li>
            <li className="">Take regularly to achieve the full effect.</li>
            <li className="">Continuous use more effective than as needed</li>
          </ul>
        </div>
      );
    },
    populationLabel: "Intranasal Corticosteroids/ Antihistamines",
    pregnancy: () => {
      return (
        <ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
          <li className="">
            Refer pregnant patients to their primary care provider.
          </li>
          <li className="">
            Differential diagnosis for pregnancy rhinitis and allergic rhinitis
            cannot be distinguished.
          </li>
        </ul>
      )
    },
    breastfeeding: () => {
      return (<ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
        <li className="">
          Intranasal corticosteroids are considered compatible while
          breastfeeding.
        </li>
        <li className="">
          Always review risk versus benefit assessment when prescribing when
          nursing.
        </li>
      </ul>);
    },
    pediatrics: () => {
      return (
        <ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
          <li className="">
            Pharmacotherapy recommendations are comparable in adults and children.
          </li>
          <li className="">
            Intranasal Corticosteroids preferred agents: budesonide, fluticasone
            propionate, mometasone
          </li>
          <li className="">
            There are some concerns regarding growth suppression in children with
            prolonged use at recommended doses.
          </li>
        </ul>
      )
    }
  },
  {
    type: "addOnTherapyOralAntihistamines",
    cardType: "addOn",
    header: "Add On Therapy (Optional)",
    subheader: "Oral Antihistamines",
    smallHeader: "Treat itchy nose, sneezing and rhinorrhea. ",
    clinicalPoints: () => {
      return (
        <div>
          <p className="text-[14px] text-gray-700 font-bold">
            Second Generation Oral Antihistamines
          </p>
          <ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
            <li className="">
              Intranasal corticosteroids are often combined with oral antihistamines
              to treat severe or resistant cases
            </li>
            <li className="">
              Longer lasting; have less sedation; Cetirizine is most sedating
            </li>
            <li className="">
              If one antihistamine is not working, can switch to a different one
            </li>
            <li className="">
              Fexofenadine, cetirizine and desloratadine have some decongestant
              activity, although only <b>desloratadine</b> has an actual indication
            </li>
            <li className="">
              May reduce symptoms of allergic conjunctivitis -itching and tearing-
            </li>
            <li className="">
              Most effective when taken prophylactically, & taken regularly for duration of allergen contact (allergy season)
            </li>
            <li className="">
              <b>
                RUPALL NOTE : Use in patients with renal or hepatic impairment is not
                recommended due to no clinical experience.
              </b>
            </li>
          </ul>
        </div>
      );
    },
    specialPopulationPoints: () => {
      return (
        <div className="">
          <p className="text-[14px] text-gray-700 font-bold">
            Second Generation Oral Antihistamines
          </p>
          <p className="text-[14px] text-gray-700 font-bold">Pregnancy:</p>
          <ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
            <li className="">
              Refer pregnant patients to their primary care provider.
            </li>
            <li className="">
              Differential diagnosis for pregnancy rhinitis and allergic rhinitis
              cannot be distinguished.
            </li>
          </ul>
          <br />
          <p className="text-[14px] text-gray-700 font-bold">Breastfeeding:</p>
          <ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
            <li className="">
              Second-generation antihistamines are considered compatible while
              breastfeeding
            </li>
            <li className="">Monitor infant for sedation with cetirizine.</li>
            <li className="">
              Avoid bilastine and rupatadine due to lack of safety data.
            </li>
          </ul>
        </div>
      );
    },
  },
];

export const paediatricPrescriptionOralAntihistamines = {
  type: "Prescription Options",
  medications: [
    {
      name: "Bilastine (Blexten)",
      dosages: [
        {
          age: "Children 4-11 y (≥16 kg)",
          dosage: "10 mg Once daily",
          medicine: {
            identifier: "04000050##2.5MG/ML##ORAL LIQUID",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Bilastine (Blexten) 2.5mg/ml oral liquid",
            dose: "10mg",
            form: "oral liquid",
            frequency: "Once a day",
            route: "PO",
            prn: null,
            prnDetail: null,
            doseOptions: null,
            formOptions: null,
            routeOptions: null,
            din: null,
            dispenseQuantity: "120 ml",
            dispenseUnit: null,
            value: "04000050##2.5MG/ML##ORAL LIQUID",
            label: "Bilastine (Blexten) 2.5mg/ml oral liquid",
            sig: "Take 10 mg (4 ml) once daily by mouth",
            reason: "seasonal allergy",
            autoFill: true,
          },
        },
      ],
    },
    {
      name: "Rupatadine (Rupall)",
      dosages: [
        {
          age: "Children 2-11 y (10-25 kg)",
          dosage: "2.5 mg Once Daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 2.5 mg/day
                </p>
              </div>
            );
          },
          medicine: {
            identifier: "04000051##1MG/ML##ORAL LIQUID",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Rupatadine (Rupall) 1mg/ml oral liquid",
            dose: "2.5 mg",
            form: "oral liquid",
            frequency: "Once a day",
            route: "PO",
            prn: null,
            prnDetail: null,
            doseOptions: null,
            formOptions: null,
            routeOptions: null,
            din: null,
            dispenseQuantity: "120 ml",
            dispenseUnit: null,
            autoFill: true,
            value: "04000051##1MG/ML##ORAL LIQUID",
            label: "Rupatadine (Rupall) 1mg/ml oral liquid",
            sig: "Take 2.5 mg (2.5 ml) once daily by mouth",
            reason: "seasonal allergy",
          },
        },
        {
          age: "Children 2-11 y (> 25 kg)",
          dosage: "5 mg daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">Maximum 5 mg/day</p>
              </div>
            );
          },
          medicine: {
            identifier: "04000051##1MG/ML##ORAL LIQUID",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Rupatadine (Rupall) 1mg/ml oral liquid",
            dose: "5 mg",
            form: "oral liquid",

            route: "PO",
            prn: null,
            prnDetail: null,
            doseOptions: null,
            formOptions: null,
            routeOptions: null,
            din: null,
            dispenseQuantity: "120 ml",
            dispenseUnit: null,
            value: "04000051##1MG/ML##ORAL LIQUID",
            label: "Rupatadine (Rupall) 1mg/ml oral liquid",
            frequency: "Once a day",
            autoFill: true,
            sig: "Take 5 mg (5 ml) once daily by mouth",
            reason: "seasonal allergy",
          },
        },
      ],
    },
  ],
};

export const paediatricNonPrescriptionOralAntihistamines = {
  type: "Non-Prescription Options",
  medications: [
    {
      name: "Cetirizine (Reactine)",
      dosages: [
        {
          age: "Children 6-11 months",
          dosage: "2.5 mg Once Daily",
          medicine: {
            identifier: "04000007##5MG/5ML##SYRUP",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Cetirizine (Reactine) 5mg/5ml syrup",
            dose: "2.5 mg",
            form: "syrup",
            route: "PO",
            prn: null,
            prnDetail: null,
            doseOptions: null,
            formOptions: null,
            routeOptions: null,
            din: null,
            dispenseQuantity: "118ml",
            dispenseUnit: null,
            value: "04000007##5MG/5ML##SYRUP",
            label: "Cetirizine (Reactine) 5mg/5ml syrup",
            frequency: "Once a day",
            autoFill: true,
            sig: "Take 2.5 mg (2.5 ml) once daily by mouth",
            reason: "seasonal allergy",
          },
        },
        {
          age: "Children 12-23 months",
          dosage: "2.5 mg Once Daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 2.5mg Q12H
                </p>
              </div>
            );
          },
          medicine: {
            identifier: "04000007##5MG/5ML##SYRUP",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Cetirizine (Reactine) 5mg/5ml syrup",
            dose: "2.5 mg",
            form: "syrup",
            route: "PO",
            prn: null,
            prnDetail: null,
            doseOptions: null,
            formOptions: null,
            routeOptions: null,
            din: null,
            dispenseQuantity: "118ml",
            dispenseUnit: null,
            value: "04000007##5MG/5ML##SYRUP",
            label: "Cetirizine (Reactine) 5mg/5ml syrup",
            frequency: "Once a day",
            autoFill: true,
            sig: "Take 2.5 mg (2.5 ml) once daily by mouth",
            reason: "seasonal allergy",
          },
        },
        {
          age: "Children 2-5 years",
          dosage: "2.5 mg Daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 5mg/day in 1-2 doses
                </p>
              </div>
            );
          },
          medicine: {
            identifier: "04000007##5MG/5ML##SYRUP",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Cetirizine (Reactine) 5mg/5ml syrup",
            dose: "2.5 mg",
            form: "syrup",
            route: "PO",
            prn: null,
            prnDetail: null,
            doseOptions: null,
            formOptions: null,
            routeOptions: null,
            din: null,
            dispenseQuantity: "118ml",
            dispenseUnit: null,
            value: "04000007##5MG/5ML##SYRUP",
            label: "Cetirizine (Reactine) 5mg/5ml syrup",
            frequency: "Once a day",
            autoFill: true,
            sig: "Take 2.5 mg (2.5 ml) once daily by mouth",
            reason: "seasonal allergy",
          },
        },
      ],
    },
    {
      name: "Desloratadine (Aerius)",
      dosages: [
        {
          age: "Children 6-11 months",
          dosage: "1 mg once daily",
          medicine: {
            identifier: "04000047##2.5MG/5ML##SYRUP",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Desloratadine (Aerius kids) 2.5mg/5ml syrup",
            dose: "1 mg",
            form: "syrup",
            route: "PO",
            prn: null,
            prnDetail: null,
            doseOptions: null,
            formOptions: null,
            routeOptions: null,
            din: null,
            dispenseQuantity: "100 ml",
            dispenseUnit: null,
            value: "04000047##2.5MG/5ML##SYRUP",
            label: "Desloratadine (Aerius kids) 2.5mg/5ml syrup",
            frequency: "Once a day",
            autoFill: true,
            sig: "Take 1 mg (2 ml) once daily by mouth",
            reason: "seasonal allergy",
          },
        },
        {
          age: "Children 1-5 years",
          dosage: "1.25 mg once daily",
          medicine: {
            identifier: "04000047##2.5MG/5ML##SYRUP",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Desloratadine (Aerius kids) 2.5mg/5ml syrup",
            dose: "1.25 mg",
            form: "syrup",
            route: "PO",
            prn: null,
            prnDetail: null,
            doseOptions: null,
            formOptions: null,
            routeOptions: null,
            din: null,
            dispenseQuantity: "100 ml",
            dispenseUnit: null,
            value: "04000047##2.5MG/5ML##SYRUP",
            label: "Desloratadine (Aerius kids) 2.5mg/5ml syrup",
            frequency: "Once a day",
            autoFill: true,
            sig: "Take 1.25 mg (2.5 ml) once daily by mouth",
            reason: "seasonal allergy",
          },
        },
        {
          age: "Children 6-11 years",
          dosage: "2.5 mg once daily",
          medicine: {
            identifier: "04000047##2.5MG/5ML##SYRUP",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Desloratadine (Aerius kids) 2.5mg/5ml syrup",
            dose: "2.5 mg",
            form: "syrup",
            route: "PO",
            prn: null,
            prnDetail: null,
            doseOptions: null,
            formOptions: null,
            routeOptions: null,
            din: null,
            dispenseQuantity: "100 ml",
            dispenseUnit: null,
            value: "04000047##2.5MG/5ML##SYRUP",
            label: "Desloratadine (Aerius kids) 2.5mg/5ml syrup",
            frequency: "Once a day",
            autoFill: true,
            sig: "Take 2.5 mg (5 ml) once daily by mouth",
            reason: "seasonal allergy",
          },
        },
      ],
    },
    {
      name: "Fexofenadine (Allegra)",
      dosages: [{ age: "Children 2-11 years", dosage: "30 mg Q12H" }],
    },
    {
      name: "Loratadine (Claritin)",
      dosages: [
        {
          age: "Children 2-5 years",
          dosage: "5 mg Once Daily",
          medicine: {
            identifier: "04000021##5MG/5ML##SYRUP",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Loratadine (Claritin) 5mg/5ml syrup",
            dose: "5 mg",
            form: "syrup",
            route: "PO",
            prn: null,
            prnDetail: null,
            doseOptions: null,
            formOptions: null,
            routeOptions: null,
            din: null,
            dispenseQuantity: "100 ml",
            dispenseUnit: null,
            value: "04000021##5MG/5ML##SYRUP",
            label: "Loratadine (Claritin) 5mg/5ml syrup",
            frequency: "Once a day",
            autoFill: true,
            sig: "Take 5 mg (5 ml) once daily by mouth",
            reason: "seasonal allergy",
          },
        },
        {
          age: "Children >5 years",
          dosage: "10 mg Once Daily",
          medicine: {
            identifier: "04000021##5MG/5ML##SYRUP",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Loratadine (Claritin) 5mg/5ml syrup",
            dose: "10 mg",
            form: "syrup",
            route: "PO",
            prn: null,
            prnDetail: null,
            doseOptions: null,
            formOptions: null,
            routeOptions: null,
            din: null,
            dispenseQuantity: "100 ml",
            dispenseUnit: null,
            value: "04000021##5MG/5ML##SYRUP",
            label: "Loratadine (Claritin) 5mg/5ml syrup",
            frequency: "Once a day",
            autoFill: true,
            sig: "Take 10 mg (10 ml) once daily by mouth",
            reason: "seasonal allergy",
          },
        },
      ],
    },
  ],
};

export const adultPrescriptionOralAntihistamines = {
  type: "Prescription Options",
  medications: [
    {
      name: "Bilastine (Blexten)",
      dosages: [
        {
          age: "Adults and children ≥12 y",
          dosage: "20 mg Once Daily",
          medicine: {
            identifier: "04000050##20MG##TABLET",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Bilastine (Blexten) 20mg tablet",
            route: "PO",
            dose: "20mg",
            form: "tablet",
            prn: null,
            prnDetail: null,
            doseOptions: null,
            formOptions: null,
            routeOptions: null,
            din: null,
            value: "04000050##20MG##TABLET",
            label: "Bilastine (Blexten) 20mg tablet",
            autoFill: true,
            dispenseQuantity: "30 tablets",
            dispenseUnit: null,
            frequency: "Once a day",
            sig: "Take one tablet once daily by mouth",
            reason: "seasonal allergy",
          },
        },
      ],
    },
    {
      name: "Rupatadine (Rupall)",
      dosages: [
        {
          age: "Adults and children ≥12 y",
          dosage: "10 mg Once Daily",
          medicine: {
            identifier: "04000051##10MG##TABLET",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Rupatadine (Rupall) 10mg tablet",
            dose: "10mg",
            form: "tablet",
            frequency: "Once a day",
            route: "PO",
            prn: null,
            prnDetail: null,
            doseOptions: null,
            formOptions: null,
            routeOptions: null,
            din: null,
            value: "04000051##10MG##TABLET",
            label: "Rupatadine (Rupall) 10mg tablet",
            autoFill: true,
            dispenseQuantity: "30 tablets",
            dispenseUnit: null,
            sig: "Take one tablet once daily by mouth",
            reason: "seasonal allergy",
          },
        },
      ],
    },
  ],
};

export const adultNonPrescriptionOralAntihistamines = {
  type: "Non-Prescription Options",
  medications: [
    {
      name: "Cetirizine (Reactine)",
      dosages: [
        {
          age: "Adults and children ≥6 y",
          dosage: "5 mg Once Daily",
          medicine: {
            identifier: "04000007##10MG##TABLET",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Cetirizine (Reactine) 10mg tablet",
            dose: "5mg",
            form: "tablet",
            route: "PO",
            frequency: "Once a day",
            prn: null,
            prnDetail: null,
            doseOptions: null,
            formOptions: null,
            routeOptions: null,
            autoFill: true,
            din: null,
            value: "04000007##10MG##TABLET",
            label: "Cetirizine (Reactine) 10mg tablet",
            dispenseQuantity: "30 tablets",
            dispenseUnit: null,
            sig: "Take one tablet once daily by mouth",
            reason: "seasonal allergy",
          },
        },
         {
          age: "Adults and children ≥6 y",
          dosage: "10 mg Once Daily",
          medicine: {
            identifier: "04000007##10MG##TABLET",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Cetirizine (Reactine) 10mg tablet",
            dose: "10mg",
            form: "tablet",
            route: "PO",
            frequency: "Once a day",
            prn: null,
            prnDetail: null,
            doseOptions: null,
            formOptions: null,
            routeOptions: null,
            autoFill: true,
            din: null,
            value: "04000007##10MG##TABLET",
            label: "Cetirizine (Reactine) 10mg tablet",
            dispenseQuantity: "30 tablets",
            dispenseUnit: null,
            sig: "Take one tablet once daily by mouth",
            reason: "seasonal allergy",
          },
        },
         {
          age: "Adults and children ≥6 y",
          dosage: "20 mg Once Daily",
          medicine: {
            identifier: "04000007##10MG##TABLET",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Cetirizine (Reactine) 20mg tablet",
            dose: "20mg",
            form: "tablet",
            route: "PO",
            frequency: "Once a day",
            prn: null,
            prnDetail: null,
            doseOptions: null,
            formOptions: null,
            routeOptions: null,
            autoFill: true,
            din: null,
            value: "04000007##10MG##TABLET",
            label: "Cetirizine (Reactine) 20mg tablet",
            dispenseQuantity: "30 tablets",
            dispenseUnit: null,
            sig: "Take one tablet once daily by mouth",
            reason: "seasonal allergy",
          },
        },
      ],
    },
    {
      name: "Desloratadine (Aerius)",
      dosages: [
        {
          age: "Adults and children ≥12 y",
          dosage: "5 mg Once Daily",
          medicine: {
            identifier: "04000047##5MG##TABLET",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Desloratadine (Aerius) 5mg tablet",
            dose: "5mg",
            form: "tablet",
            route: "PO",
            prn: null,
            prnDetail: null,
            doseOptions: null,
            formOptions: null,
            routeOptions: null,
            din: null,
            value: "04000047##5MG##TABLET",
            label: "Desloratadine (Aerius) 5mg tablet",
            frequency: "Once a day",
            dispenseQuantity: "30 tablets",
            dispenseUnit: null,
            autoFill: true,
            sig: "Take one tablet once daily by mouth",
            reason: "seasonal allergy",
          },
        },
      ],
    },
    {
      name: "Fexofenadine (Allegra)",
      dosages: [
        {
          age: "Adults and children ≥12 y",
          dosage: "60 mg Q12H",
          medicine: {
            identifier: "04000036##60MG##TABLET",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Fexofenadine (Allegra 12 hours) 60mg tablet",
            dose: "60mg",
            form: "tablet",
            route: "PO",
            prn: null,
            prnDetail: null,
            doseOptions: null,
            formOptions: null,
            routeOptions: null,
            din: null,
            value: "04000036##60MG##TABLET",
            label: "Fexofenadine (Allegra 12 hours) 60mg tablet",
            frequency: "BID",
            dispenseQuantity: "60 tablets",
            dispenseUnit: null,
            autoFill: true,
            sig: "Take one tablet twice daily by mouth",
            reason: "seasonal allergy",
          },
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 180 mg/day - 12hrs Formulation
                </p>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 120 mg/day - 24hrs Formulation
                </p>
              </div>
            );
          },
        },
      ],
    },
    {
      name: "Loratadine (Claritin)",
      dosages: [
        {
          age: "Adults and children ≥5 y",
          dosage: "10 mg Once Daily",
          medicine: {
            identifier: "04000021##10MG##TABLET",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Loratadine (Claritin) 10mg tablet",
            dose: "10mg",
            form: "tablet",
            route: "PO",
            prn: null,
            prnDetail: null,
            doseOptions: null,
            formOptions: null,
            routeOptions: null,
            din: null,
            value: "04000021##10MG##TABLET",
            label: "Loratadine (Claritin) 10mg tablet",
            frequency: "Once a day",
            dispenseQuantity: "30 tablets",
            dispenseUnit: null,
            autoFill: true,
            sig: "Take one tablet once daily by mouth",
            reason: "seasonal allergy",
          },
        },
      ],
    },
  ],
};

export const adultPrescriptionIntranasalCorticosteroids = {
  type: "Prescription Options",
  medications: [
    {
      name: "Beclomethasone Dipropionate",
      dose: " 50mcg/ spray",
      identifier: "16098",
      subname: "",
      dosages: [
        {
          age: "Adults",
          dosage: "2 sprays in each nostril twice daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 12 sprays [600 mcg] per day
                </p>
              </div>
            );
          },
          medicine: {
            identifier: "52080401##50MCG##NASAL SPRAY",
            type: "Generx",
            provincialCoverage: null,
            displayText:
              "Beclomethasone-nasal (Beconase | vancenase) 50mcg nasal spray",
            dose: "2 sprays",
            form: "nasal spray",
            frequency: "BID",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            formOptions: null,
            routeOptions: null,
            auxLabels: null,
            value: "52080401##50MCG##NASAL SPRAY",
            label: "Beclomethasone-nasal (Beconase | vancenase) 50mcg nasal spray",
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            autoFill: true,
            reason: "seasonal allergy",
            sig: "Use 2 spray in each nostril twice daily",
            dispenseQuantity: "1",
          },
        },
      ],
    },
    {
      name: "Budesonide (Rhinocort Aqua)",
      dose: " - Nasal Suspension (64mcg/ metered dose)",
      subname: "",
      dosages: [
        {
          age: "Adults and children ≥6 y:",
          dosage: "Initial Dose: \n2 sprays in each nostril once daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 256 mcg/day
                </p>
              </div>
            );
          },
          medicine: {
            identifier: "52080402##64MCG##NASAL SPRAY",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Budesonide-nasal (Rhinocort aqua) 64mcg nasal spray",
            dose: "2 sprays",
            form: "nasal spray",
            frequency: "once a day",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            formOptions: null,
            routeOptions: null,
            din: null,
            dispenseQuantity: "1",
            dispenseUnit: null,
            value: "52080402##64MCG##NASAL SPRAY",
            autoFill: true,
            reason: "seasonal allergy",
            label: "Budesonide-nasal (Rhinocort aqua) 64mcg nasal spray",
            sig: "Use 2 spray in each nostril once daily",
          },
        },
        {
          age: "Adults and children ≥6 y:",
          dosage: "Initial Dose: \n1 spray in each nostril twice daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 256 mcg/day
                </p>
              </div>
            );
          },
          medicine: {
            identifier: "52080402##64MCG##NASAL SPRAY",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Budesonide-nasal (Rhinocort aqua) 64mcg nasal spray",
            dose: "1 spray",
            form: "nasal spray",
            frequency: "BID",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            formOptions: null,
            routeOptions: null,
            din: null,
            dispenseQuantity: "1",
            dispenseUnit: null,
            value: "52080402##64MCG##NASAL SPRAY",
            autoFill: true,
            reason: "seasonal allergy",
            label: "Budesonide-nasal (Rhinocort aqua) 64mcg nasal spray",
            sig: "Use 1 spray in each nostril twice daily",
          },
        },
        {
          age: "Adults and children ≥6 y:",
          dosage: "Maintenance Dose: \n1 spray in each nostril once daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 256 mcg/day
                </p>
              </div>
            );
          },
          medicine: {
            identifier: "52080402##64MCG##NASAL SPRAY",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Budesonide-nasal (Rhinocort aqua) 64mcg nasal spray",
            dose: "1 spray",
            form: "nasal spray",
            frequency: "BID",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            formOptions: null,
            routeOptions: null,
            din: null,
            dispenseQuantity: "1",
            dispenseUnit: null,
            value: "52080402##64MCG##NASAL SPRAY",
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            autoFill: true,
            reason: "seasonal allergy",
            label: "Budesonide-nasal (Rhinocort aqua) 64mcg nasal spray",
            sig: "Use 1 spray in each nostril twice daily",
          },
        },
      ],
    },
    {
      name: "Budesonide (Rhinocort Aqua)",
      dose: " - Nasal Powder (100mcg/ dose)",
      subname: "",
      dosages: [
        {
          age: "Adults and children ≥6 y:",
          dosage: "Initial Dose: \n2 applications in each nostril once daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 400 mcg/day
                </p>
              </div>
            );
          },
          medicine: {
            identifier: "52080402##100MCG##NASAL POWDER",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Budesonide-nasal (Rhinocort) 100mcg nasal powder",
            dose: "2 applications",
            form: "nasal powder",
            frequency: "once a day",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            formOptions: null,
            routeOptions: null,
            din: null,
            dispenseQuantity: "1",
            dispenseUnit: null,
            value: "52080402##100MCG##NASAL POWDER",
            label: "Budesonide-nasal (Rhinocort) 100mcg nasal powder",
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            autoFill: true,
            reason: "seasonal allergy",
            sig: "Use 2 applications in each nostril once daily",
          },
        },
        {
          age: "Adults and children ≥6 y:",
          dosage: "Initial Dose: \n1 applications in each nostril twice daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 400 mcg/day
                </p>
              </div>
            );
          },
          medicine: {
            identifier: "52080402##100MCG##NASAL POWDER",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Budesonide-nasal (Rhinocort) 100mcg nasal powder",
            dose: "2 applications",
            form: "nasal powder",
            frequency: "once a day",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            formOptions: null,
            routeOptions: null,
            din: null,
            dispenseQuantity: "1",
            dispenseUnit: null,
            value: "52080402##100MCG##NASAL POWDER",
            label: "Budesonide-nasal (Rhinocort) 100mcg nasal powder",
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            autoFill: true,
            reason: "seasonal allergy",
            sig: "Use 1 applications in each nostril twice daily",
          },
        },
        {
          age: "Adults and children ≥6 y:",
          dosage: "Maintenance Dose: \n1 application in each nostril once daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 400 mcg/day
                </p>
              </div>
            );
          },
          medicine: {
            identifier: "52080402##100MCG##NASAL POWDER",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Budesonide-nasal (Rhinocort) 100mcg nasal powder",
            dose: "2 applications",
            form: "nasal powder",
            frequency: "once a day",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            formOptions: null,
            routeOptions: null,
            din: null,
            dispenseUnit: null,
            value: "52080402##100MCG##NASAL POWDER",
            label: "Budesonide-nasal (Rhinocort) 100mcg nasal powder",
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            autoFill: true,
            reason: "seasonal allergy",
            sig: "Use 1 application in each nostril once daily",
            dispenseQuantity: "1",
          },
        },
      ],
    },
    {
      name: "Ciclesonide (Omnaris)",
      dose: " 50 mcg/spray",
      subname: "",
      dosages: [
        {
          age: "Adults and children ≥12 y",
          dosage: "2 Sprays in each nostril once daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 200 mcg/day
                </p>
              </div>
            );
          },
          medicine: {
            identifier: "52080409##50MCG##NASAL SPRAY",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Ciclesonide-nasal (Omnaris) 50mcg nasal spray",
            dose: "2 sprays",
            form: "nasal spray",
            frequency: "once a day",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            formOptions: null,
            routeOptions: null,
            auxLabels: null,
            value: "52080409##50MCG##NASAL SPRAY",
            label: "Ciclesonide-nasal (Omnaris) 50mcg nasal spray",
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            autoFill: true,
            reason: "seasonal allergy",
            sig: "Use 2 sprays in each nostril once daily",
            dispenseQuantity: "1",
          },
        },
      ],
    },
    {
      name: "Fluticasone Furoate (Avamys)",
      dose: " 27.5 mcg/spray ",
      subname: "",
      dosages: [
        {
          age: "Adults and children ≥12 y",
          dosage: "2 Sprays in each nostril once daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 110 mcg/day
                </p>
              </div>
            );
          },
          medicine: {
            identifier: "52080408##27.5MCG##NASAL SPRAY",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Fluticasone-furoate-nasal (Avamys) 27.5mcg nasal spray",
            dose: "2 sprays",
            form: "nasal spray",
            frequency: "once a day",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            formOptions: null,
            routeOptions: null,
            auxLabels: null,
            value: "52080408##27.5MCG##NASAL SPRAY",
            label: "Fluticasone-furoate-nasal (Avamys) 27.5mcg nasal spray",
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            autoFill: true,
            reason: "seasonal allergy",
            sig: "Use 2 sprays in each nostril once daily",
            dispenseQuantity: "1",
          },
        },
      ],
    },
    {
      name: "Fluticasone Propionate (Flonase)",
      dose: " 50 mcg/spray",
      subname:
        "*Rx Required: A prescription is required for patients <18 years old.",
      dosages: [
        {
          age: "Adults and children ≥12 y",
          dosage: "2 Sprays in each nostril once daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 400 mcg/day
                </p>
              </div>
            );
          },
          medicine: {
            identifier: "52080406##50MCG##NASAL SPRAY",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Fluticasone-propionate-nasal (Flonase) 50mcg nasal spray",
            dose: "2 sprays",
            form: "nasal spray",
            frequency: "once a day",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            formOptions: null,
            routeOptions: null,
            auxLabels: null,
            value: "52080406##50MCG##NASAL SPRAY",
            label: "Fluticasone-propionate-nasal (Flonase) 50mcg nasal spray",
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            autoFill: true,
            reason: "seasonal allergy",
            sig: "Use 2 sprays in each nostril once daily",
            dispenseQuantity: "1",
          },
          cps: "May increase to BID in severe situations",
        },
      ],
    },
    {
      name: "Mometasone (Nasonex)",
      dose: " 50 mcg/spray",
      subname: "",
      dosages: [
        {
          age: "Adults and children ≥12 y",
          dosage: "2 Sprays in each nostril once daily.",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 200 mcg/day
                </p>
              </div>
            );
          },
          cps: "May decrease to 1 spray in each nostril once daily for maintenance. May increase to BID in severe situations.",
          medicine: {
            identifier: "52080407##50MCG##NASAL SPRAY",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Mometasone-furoate-nasal (Nasonex) 50mcg nasal spray",
            dose: "2 sprays",
            form: "nasal spray",
            frequency: "once a day",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            formOptions: null,
            routeOptions: null,
            auxLabels: null,
            value: "52080407##50MCG##NASAL SPRAY",
            label: "Mometasone-furoate-nasal (Nasonex) 50mcg nasal spray",
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            autoFill: true,
            reason: "seasonal allergy",
            sig: "Use 2 sprays in each nostril once daily",
            dispenseQuantity: "1",
          },
        },
      ],
    },
    {
      name: "Triamcinolone acetonide (Nasacort AQ, Nasacort Allergy 24HR)",
      dose: " 55 mcg/spray",
      subname: "",
      dosages: [
        {
          age: "Adults and children ≥12 y",
          dosage: "2 Sprays in each nostril once daily.",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 220 mcg/day
                </p>
              </div>
            );
          },
          cps: "May decrease to 1 spray in each nostril once daily.",
          medicine: {
            identifier: "52080404##55MCG##NASAL SPRAY",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Triamcinolone-nasal (Nasacort aqueous) 55mcg nasal spray",
            dose: "2 sprays",
            form: "nasal spray",
            frequency: "once a day",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            formOptions: null,
            routeOptions: null,
            auxLabels: null,
            value: "52080404##55MCG##NASAL SPRAY",
            label: "Triamcinolone-nasal (Nasacort aqueous) 55mcg nasal spray",
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            autoFill: true,
            reason: "seasonal allergy",
            sig: "Use 2 sprays in each nostril once daily",
            dispenseQuantity: "1",
          },
        },
      ],
    },
  ],
};

export const paediatricPrescriptionIntranasalCorticosteroids = {
  type: "Prescription Options",
  medications: [
    {
      name: "Beclomethasone Dipropionate",
      dose: " 50mcg/ spray",
      subname: "",
      dosages: [
        {
          age: "Children ≥6 y",
          dosage: "2 sprays in each nostril twice daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 8 sprays [400 mcg] per day
                </p>
              </div>
            );
          },
          medicine: {
            identifier: "52080401##50MCG##NASAL SPRAY",
            type: "Generx",
            provincialCoverage: null,
            displayText:
              "Beclomethasone-nasal (Beconase | vancenase) 50mcg nasal spray",
            dose: "2 sprays",
            form: "nasal spray",
            frequency: "BID",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            formOptions: null,
            routeOptions: null,
            auxLabels: null,
            value: "52080401##50MCG##NASAL SPRAY",
            label: "Beclomethasone-nasal (Beconase | vancenase) 50mcg nasal spray",
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            autoFill: true,
            reason: "seasonal allergy",
            sig: "Use 2 spray in each nostril twice daily",
            dispenseQuantity: "1",
          },
        },
      ],
    },
    {
      name: "Budesonide (Rhinocort Aqua)",
      dose: " - Nasal Suspension (64mcg/ metered dose)",
      subname: "",
      dosages: [
        {
          age: "Children ≥6 y: as per adults",
          dosage: "Initial Dose: \n2 sprays in each nostril once daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 256 mcg/day
                </p>
              </div>
            );
          },
          medicine: {
            identifier: "52080402##64MCG##NASAL SPRAY",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Budesonide-nasal (Rhinocort aqua) 64mcg nasal spray",
            dose: "2 sprays",
            form: "nasal spray",
            frequency: "once a day",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            formOptions: null,
            routeOptions: null,
            din: null,
            dispenseUnit: null,
            value: "52080402##64MCG##NASAL SPRAY",
            autoFill: true,
            reason: "seasonal allergy",
            label: "Budesonide-nasal (Rhinocort aqua) 64mcg nasal spray",
            sig: "Use 2 spray in each nostril once daily",
            dispenseQuantity: "1",
          },
        },
        {
          age: "Children ≥6 y: as per adults",
          dosage: "Initial Dose: \n1 spray in each nostril twice daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 256 mcg/day
                </p>
              </div>
            );
          },
          medicine: {
            identifier: "52080402##64MCG##NASAL SPRAY",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Budesonide-nasal (Rhinocort aqua) 64mcg nasal spray",
            dose: "1 spray",
            form: "nasal spray",
            frequency: "BID",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            formOptions: null,
            routeOptions: null,
            din: null,
            dispenseQuantity: "1",
            dispenseUnit: null,
            value: "52080402##64MCG##NASAL SPRAY",
            autoFill: true,
            reason: "seasonal allergy",
            label: "Budesonide-nasal (Rhinocort aqua) 64mcg nasal spray",
            sig: "Use 1 spray in each nostril twice daily",
          },
        },
        {
          age: "Children ≥6 y: as per adults",
          dosage: "Maintenance Dose: \n1 spray in each nostril once daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 256 mcg/day
                </p>
              </div>
            );
          },
          medicine: {
            identifier: "52080402##64MCG##NASAL SPRAY",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Budesonide-nasal (Rhinocort aqua) 64mcg nasal spray",
            dose: "1 spray",
            form: "nasal spray",
            frequency: "BID",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            formOptions: null,
            routeOptions: null,
            din: null,
            dispenseQuantity: "1",
            dispenseUnit: null,
            value: "52080402##64MCG##NASAL SPRAY",
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            autoFill: true,
            reason: "seasonal allergy",
            label: "Budesonide-nasal (Rhinocort aqua) 64mcg nasal spray",
            sig: "Use 1 spray in each nostril twice daily",
          },
        },
      ],
    },
    {
      name: "Budesonide (Rhinocort Aqua)",
      dose: " - Nasal Powder (100mcg/ dose)",
      subname: "",
      dosages: [
        {
          age: "Children ≥6 y: as per adults",
          dosage: "Initial Dose: \n2 applications in each nostril once daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 400 mcg/day
                </p>
              </div>
            );
          },
          medicine: {
            identifier: "52080402##100MCG##NASAL POWDER",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Budesonide-nasal (Rhinocort) 100mcg nasal powder",
            dose: "2 applications",
            form: "nasal powder",
            frequency: "once a day",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            formOptions: null,
            routeOptions: null,
            din: null,
            dispenseQuantity: "1",
            dispenseUnit: null,
            value: "52080402##100MCG##NASAL POWDER",
            label: "Budesonide-nasal (Rhinocort) 100mcg nasal powder",
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            autoFill: true,
            reason: "seasonal allergy",
            sig: "Use 2 applications in each nostril once daily",
          },
        },
        {
          age: "Children ≥6 y: as per adults",
          dosage: "Initial Dose: \n1 applications in each nostril twice daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 400 mcg/day
                </p>
              </div>
            );
          },
          medicine: {
            identifier: "52080402##100MCG##NASAL POWDER",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Budesonide-nasal (Rhinocort) 100mcg nasal powder",
            dose: "2 applications",
            form: "nasal powder",
            frequency: "once a day",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            formOptions: null,
            routeOptions: null,
            din: null,
            dispenseQuantity: "1",
            dispenseUnit: null,
            value: "52080402##100MCG##NASAL POWDER",
            label: "Budesonide-nasal (Rhinocort) 100mcg nasal powder",
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            autoFill: true,
            reason: "seasonal allergy",
            sig: "Use 1 applications in each nostril twice daily",
          },
        },
        {
          age: "Children ≥6 y: as per adults",
          dosage: "Maintenance Dose: \n1 application in each nostril once daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 400 mcg/day
                </p>
              </div>
            );
          },
          medicine: {
            identifier: "52080402##100MCG##NASAL POWDER",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Budesonide-nasal (Rhinocort) 100mcg nasal powder",
            dose: "2 applications",
            form: "nasal powder",
            frequency: "once a day",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            formOptions: null,
            routeOptions: null,
            din: null,
            dispenseQuantity: "1",
            dispenseUnit: null,
            value: "52080402##100MCG##NASAL POWDER",
            label: "Budesonide-nasal (Rhinocort) 100mcg nasal powder",
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            autoFill: true,
            reason: "seasonal allergy",
            sig: "Use 1 application in each nostril once daily",
          },
        },
      ],
    },
    {
      name: "Ciclesonide (Omnaris)",
      dose: " 50 mcg/spray",
      subname: "",
      dosages: [
        {
          age: "Children ≥ 12 y: as per adults",
          dosage: "2 Sprays in each nostril once daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 200 mcg/day
                </p>
              </div>
            );
          },
          medicine: {
            identifier: "52080409##50MCG##NASAL SPRAY",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Ciclesonide-nasal (Omnaris) 50mcg nasal spray",
            dose: "2 sprays",
            form: "nasal spray",
            frequency: "once a day",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            formOptions: null,
            routeOptions: null,
            auxLabels: null,
            value: "52080409##50MCG##NASAL SPRAY",
            label: "Ciclesonide-nasal (Omnaris) 50mcg nasal spray",
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            autoFill: true,
            reason: "seasonal allergy",
            sig: "Use 2 sprays in each nostril once daily",
            dispenseQuantity: "1",
          },
        },
      ],
    },
    {
      name: "Fluticasone Furoate (Avamys)",
      dose: " 27.5 mcg/spray ",
      subname: "",
      dosages: [
        {
          age: "Children 4-11 y",
          dosage: "1 spray in each nostril once daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 200 mcg/day
                </p>
              </div>
            );
          },
          medicine: {
            identifier: "52080408##27.5MCG##NASAL SPRAY",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Fluticasone-furoate-nasal (Avamys) 27.5mcg nasal spray",
            dose: "1 spray",
            form: "nasal spray",
            frequency: "once a day",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            formOptions: null,
            routeOptions: null,
            auxLabels: null,
            value: "52080408##27.5MCG##NASAL SPRAY",
            label: "Fluticasone-furoate-nasal (Avamys) 27.5mcg nasal spray",
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            autoFill: true,
            reason: "seasonal allergy",
            sig: "Use 1 spray in each nostril once daily",
            dispenseQuantity: "1",
          },
          cps: "Children 2-11 yr: 1 spray in each nostril once daily if needed. Decrease to 1 spray in each nostril once daily for maintenance (Maximum 110mcg/day)",
        },
        {
          age: "Children 4-11 y",
          dosage: "2 sprays in each nostril once daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 200 mcg/day
                </p>
              </div>
            );
          },
          medicine: {
            identifier: "52080408##27.5MCG##NASAL SPRAY",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Fluticasone-furoate-nasal (Avamys) 27.5mcg nasal spray",
            dose: "2 sprays",
            form: "nasal spray",
            frequency: "once a day",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            formOptions: null,
            routeOptions: null,
            auxLabels: null,
            value: "52080408##27.5MCG##NASAL SPRAY",
            label: "Fluticasone-furoate-nasal (Avamys) 27.5mcg nasal spray",
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            autoFill: true,
            reason: "seasonal allergy",
            sig: "Use 2 sprays in each nostril once daily",
            dispenseQuantity: "1",
          },
          cps: "Children 2-11 yr: 1 spray in each nostril once daily if needed. Decrease to 1 spray in each nostril once daily for maintenance (Maximum 110mcg/day)",
        },
      ],
    },
    {
      name: "Fluticasone Propionate (Flonase)",
      dose: " 50 mcg/spray",
      subname:
        "*Rx Required: A prescription is required for patients <18 years old.",
      dosages: [
        {
          age: "Children ≥12 y",
          dosage: "1 spray in each nostril once daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 200 mcg/day
                </p>
              </div>
            );
          },
          medicine: {
            identifier: "52080406##50MCG##NASAL SPRAY",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Fluticasone-propionate-nasal (Flonase) 50mcg nasal spray",
            dose: "1 spray",
            form: "nasal spray",
            frequency: "once a day",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            formOptions: null,
            routeOptions: null,
            auxLabels: null,
            value: "52080406##50MCG##NASAL SPRAY",
            label: "Fluticasone-propionate-nasal (Flonase) 50mcg nasal spray",
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            autoFill: true,
            reason: "seasonal allergy",
            sig: "Use 1 spray in each nostril once daily",
            dispenseQuantity: "1",
          },
        },
        {
          age: "Children ≥12 y",
          dosage: "2 sprays in each nostril once daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 200 mcg/day
                </p>
              </div>
            );
          },
          medicine: {
            identifier: "52080406##50MCG##NASAL SPRAY",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Fluticasone-propionate-nasal (Flonase) 50mcg nasal spray",
            dose: "2 sprays",
            form: "nasal spray",
            frequency: "once a day",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            formOptions: null,
            routeOptions: null,
            auxLabels: null,
            value: "52080406##50MCG##NASAL SPRAY",
            label: "Fluticasone-propionate-nasal (Flonase) 50mcg nasal spray",
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            autoFill: true,
            reason: "seasonal allergy",
            sig: "Use 2 sprays in each nostril once daily",
            dispenseQuantity: "1",
          },
        },
      ],
    },
    {
      name: "Mometasone (Nasonex)",
      dose: " 50 mcg/spray",
      subname: "",
      dosages: [
        {
          age: "Children 3-11 y",
          dosage: "1 Spray in each nostril once daily",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 100 mcg/day
                </p>
              </div>
            );
          },
          cps: "May increase to 2 sprays in each nostril once daily if needed. Maintenance Dose: May Decrease to 1 spray in each nostril once daily. Maximum Dose: 110mcg/day",
          medicine: {
            identifier: "52080407##50MCG##NASAL SPRAY",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Mometasone-furoate-nasal (Nasonex) 50mcg nasal spray",
            dose: "2 sprays",
            form: "nasal spray",
            frequency: "once a day",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            formOptions: null,
            routeOptions: null,
            auxLabels: null,
            value: "52080407##50MCG##NASAL SPRAY",
            label: "Mometasone-furoate-nasal (Nasonex) 50mcg nasal spray",
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            autoFill: true,
            reason: "seasonal allergy",
            sig: "Use 2 sprays in each nostril once daily",
            dispenseQuantity: "1",
          },
        },
      ],
    },
    {
      name: "Triamcinolone acetonide (Nasacort AQ, Nasacort Allergy 24HR)",
      dose: " 55 mcg/spray",
      subname:
        "*Rx Required: A prescription is required for patients <12 years old.",
      dosages: [
        {
          age: "Children 4 to 11 y",
          dosage: "1 Spray in each nostril once daily.",
          maximumDosage: () => {
            return (
              <div>
                <p className="text-body-sm text-gray-800 italic">
                  Maximum 220 mcg/day
                </p>
              </div>
            );
          },
          cps: "May increase to 2 sprays in each nostril once daily if needed. May Decrease to 1 spray in each nostril once daily for maintenance. (Maximum 110mcg/day)",
          medicine: {
            identifier: "52080404##55MCG##NASAL SPRAY",
            type: "Generx",
            provincialCoverage: null,
            displayText: "Triamcinolone-nasal (Nasacort aqueous) 55mcg nasal spray",
            dose: "2 sprays",
            form: "nasal spray",
            frequency: "once a day",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            formOptions: null,
            routeOptions: null,
            auxLabels: null,
            value: "52080404##55MCG##NASAL SPRAY",
            label: "Triamcinolone-nasal (Nasacort aqueous) 55mcg nasal spray",
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            autoFill: true,
            reason: "seasonal allergy",
            sig: "Use 2 sprays in each nostril once daily",
            dispenseQuantity: "1",
          },
        },
      ],
    },
  ],
};

export const adultPrescriptionCombination = {
  type: "Prescription Options",
  medications: [
    {
      name: "Azelastine/ Fluticasone (Dymista)",
      dose: " 50mcg/137 mcg per spray",
      dosages: [
        {
          age: "Adults and children ≥ 12 y",
          dosage: "1 spray in each nostril twice daily",
          medicine: {
            identifier: "520804+A##50+137MCG##NASAL SPRAY",
            type: "Generx",
            provincialCoverage: null,
            displayText:
              "Fluticasone-propionate-nasal + azelastine-nasal (Dymista) 50+137mcg nasal spray",
            dose: "1 spray",
            form: "nasal spray",
            frequency: "BID",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            formOptions: null,
            routeOptions: null,
            auxLabels: null,
            value: "520804+A##50+137MCG##NASAL SPRAY",
            label:
              "Fluticasone-propionate-nasal + azelastine-nasal (Dymista) 50+137mcg nasal spray",
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            dispenseQuantity: "1",
            autoFill: true,
            reason: "seasonal allergy",
            sig: "Use one spray in each nostril twice daily",
          },
        },
      ],
    },
    {
      name: "Olopatadine/ Mometasone (Ryaltris)",
      dose: " 665 mcg/ 25 mcg per spray",
      dosages: [
        {
          age: "Adults and children ≥12 y",
          dosage: "2 spray in each nostril twice daily",
          medicine: {
            identifier: "520804+B##25+665MCG##NASAL SPRAY",
            type: "Generx",
            provincialCoverage: null,
            displayText:
              "Mometasone-furoate-nasal + olopatadine-nasal (Ryaltris) 25+665mcg nasal spray",
            dose: "2 sprays",
            form: "nasal spray",
            frequency: "BID",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            formOptions: null,
            routeOptions: null,
            auxLabels: null,
            value: "520804+B##25+665MCG##NASAL SPRAY",
            label:
              "Mometasone-furoate-nasal + olopatadine-nasal (Ryaltris) 25+665mcg nasal spray",
            dispenseQuantity: "1",
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            autoFill: true,
            reason: "seasonal allergy",
            sig: "Use two sprays in each nostril twice daily",
          },
        },
      ],
    },
  ],
};

export const paediatricPrescriptionCombination = {
  type: "Prescription Options",
  medications: [
    {
      name: "Azelastine/ Fluticasone (Dymista)",
      dose: " 50mcg/137 mcg per spray",
      dosages: [
        {
          age: "Children ≥ 12 y",
          dosage: "1 spray in each nostril twice daily",
          medicine: {
            identifier: "520804+A##50+137MCG##NASAL SPRAY",
            type: "Generx",
            provincialCoverage: null,
            displayText:
              "Fluticasone-propionate-nasal + azelastine-nasal (Dymista) 50+137mcg nasal spray",
            dose: "1 spray",
            form: "nasal spray",
            frequency: "BID",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            formOptions: null,
            routeOptions: null,
            auxLabels: null,
            value: "520804+A##50+137MCG##NASAL SPRAY",
            label:
              "Fluticasone-propionate-nasal + azelastine-nasal (Dymista) 50+137mcg nasal spray",
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            autoFill: true,
            dispenseQuantity: "1",
            reason: "seasonal allergy",
            sig: "Use one spray in each nostril twice daily",
          },
        },
      ],
    },
    {
      name: "Olopatadine/ Mometasone (Ryaltris)",
      dose: " 665 mcg/ 25 mcg per spray",
      dosages: [
        {
          age: "Children 6-11 y",
          dosage: "1 spray in each nostril twice daily",
          medicine: {
            identifier: "520804+B##25+665MCG##NASAL SPRAY",
            type: "Generx",
            provincialCoverage: null,
            displayText:
              "Mometasone-furoate-nasal + olopatadine-nasal (Ryaltris) 25+665mcg nasal spray",
            dose: "1 spray",
            form: "nasal spray",
            frequency: "BID",
            route: "NASINHL",
            prn: null,
            prnDetail: null,
            formOptions: null,
            routeOptions: null,
            auxLabels: null,
            value: "520804+B##25+665MCG##NASAL SPRAY",
            label:
              "Mometasone-furoate-nasal + olopatadine-nasal (Ryaltris) 25+665mcg nasal spray",
            doseOptions: ["1 Spray", "2 Sprays", "64mcg", "50 mcg", "100 mcg"],
            autoFill: true,
            dispenseQuantity: "1",
            reason: "seasonal allergy",
            sig: "Use one spray in each nostril twice daily",
          },
        },
      ],
    },
  ],
};

export const adultPrescriptionAddOnOralDecongestants = {
  type: "Prescription Options",
  medications: [],
};

export const paediatricPrescriptionAddOnOralDecongestants = {
  type: "Prescription Options",
  medications: [],
};

export const adultPrescriptionAddOnIntranasalDecongestants = {
  type: "Non-Prescription Options",
  medications: [],
};

export const paediatricPrescriptionAddOnIntranasalDecongestants = {
  type: "Non-Prescription Options",
  medications: [],
};
